
export const getHeaders = (): string[] => [
  'Profile',
  'FMS access',
  'Portal admin',
  '2FA - Disabled',
  'Joined',
  'TOU & PP',
  'Last login',
  'Weekly',
  'Quarterly',
  'Monthly',
  'Annual',
];
